import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { ServiceProjectItemPayload } from '../models/item-payload';

export const ServiceProjectItemEditActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[service/project-item] Edit'),
  requestFail: uniqueActionType('[service/project-item] Edit fail'),
  requestSuccess: uniqueActionType('[service/project-item] Edit success'),
  requestClearErrors: uniqueActionType('[service/project-item] Edit clear errors'),
  requestClear: uniqueActionType('[service/project-item] Edit clear')
};

export class ServiceProjectItemEditAction implements PayloadAction {
  readonly type = ServiceProjectItemEditActionTypes.request;

  constructor(public payload: SendByIdPayload<ServiceProjectItemPayload>) {
  }
}

export class ServiceProjectItemEditFailAction implements PayloadAction {
  readonly type = ServiceProjectItemEditActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class ServiceProjectItemEditSuccessAction implements PayloadAction {
  readonly type = ServiceProjectItemEditActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class ServiceProjectItemEditClearErrorsAction implements PayloadAction {
  readonly type = ServiceProjectItemEditActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class ServiceProjectItemEditClearAction implements PayloadAction {
  readonly type = ServiceProjectItemEditActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
